export const Options = {
    Salutation: [
         {text:"Herr",value:"m"},
         {text:"Frau",value:"w"},
        {text:"Divers",value:"d"}
    ],
    Handicap: [
        {text:"Ja",value:"-1"},
        {text:"Nein",value:"0"}
    ]
}

